import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]

  connect() {
    this.measure = this.measure.bind(this)
    this.update = this.update.bind(this)
    this.handleScroll = this.handleScroll.bind(this)

    this.measure()
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    window.addEventListener("resize", this.measure)
    // Web fonts land after the first measurement and change how tall the text
    // is, which moves every breakpoint.
    document.fonts?.ready.then(this.measure)
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener("resize", this.measure)
    cancelAnimationFrame(this.frame)
  }

  handleScroll() {
    cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(this.update)
  }

  // The steps are stacked but still laid out, so each one reports the height
  // it would take on its own. Sharing the track out in those proportions gives
  // every step a stretch of scroll matched to how much there is to read.
  measure() {
    const heights = this.stepTargets.map((step) => step.scrollHeight || 1)
    const total = heights.reduce((sum, height) => sum + height, 0)

    let travelled = 0
    this.starts = heights.map((height) => {
      const start = travelled / total
      travelled += height
      return start
    })

    this.update()
  }

  update() {
    if (!this.starts?.length) return

    const { top, height } = this.element.getBoundingClientRect()
    const distance = height - window.innerHeight
    const progress =
      distance > 0 ? Math.min(Math.max(-top / distance, 0), 1) : 0

    let current = 0
    this.starts.forEach((start, index) => {
      if (progress >= start) current = index
    })

    this.stepTargets.forEach((step, index) => {
      step.dataset.active = index === current
    })
  }
}
